// Add this function to transform owasp_metrics into progress bar data
const transformOWASPData = (owaspMetrics) => {
  // Define all 10 OWASP categories with colors
  const owaspCategories = {
    "A01:2021": {
      label: "A01:2021 - Broken Access Control",
      color: "#3B82F6", // Red
    },
    "A02:2021": {
      label: "A02:2021 - Cryptographic Failures",
      color: "#8B5CF6", // Orange
    },
    "A03:2021": {
      label: "A03:2021 - Injection",
      color: "#06B6D4", // Amber
    },
    "A04:2021": {
      label: "A04:2021 - Insecure Design",
      color: "#F59E0B", // Green
    },
    "A05:2021": {
      label: "A05:2021 - Security Misconfiguration",
      color: "#10B981", // Blue
    },
    "A06:2021": {
      label: "A06:2021 - Vulnerable and Outdated Components",
      color: "#805ad5", // Purple
    },
    "A07:2021": {
      label: "A07:2021 - Identification and Authentication Failures",
      color: "#d53f8c", // Pink
    },
    "A08:2021": {
      label: "A08:2021 - Software and Data Integrity Failures",
      color: "#00b5d8", // Cyan
    },
    "A09:2021": {
      label: "A09:2021 - Security Logging and Monitoring Failures",
      color: "#319795", // Teal
    },
    "A10:2021": {
      label: "A10:2021 - Server-Side Request Forgery (SSRF)",
      color: "#4a5568", // Gray
    },
  };

  // Count occurrences of each OWASP category
  const owaspCounts = {};

  // Initialize all categories with 0
  Object.keys(owaspCategories).forEach((key) => {
    owaspCounts[key] = 0;
  });

  // Count actual occurrences
  owaspMetrics.forEach((item) => {
    const categoryId = item.owasp_category.split(" - ")[0]; // Extract "A01:2021" part
    if (owaspCounts.hasOwnProperty(categoryId)) {
      owaspCounts[categoryId]++;
    }
  });

  // Transform to progress bar format (only show categories with count > 0)
  return Object.entries(owaspCounts)
    .filter(([key, count]) => count > 0) // Only show categories with vulnerabilities
    .map(([key, count]) => ({
      label: owaspCategories[key].label,
      value: count,
      color: owaspCategories[key].color,
    }))
    .sort((a, b) => b.value - a.value); // Sort by count (highest first)
};

export default transformOWASPData;
